import * as React from 'react';
import { useEffect } from 'react';

/** Material UI Packages. */
import { Box } from '@mui/material';
import { DataGridPremium } from '@mui/x-data-grid-premium';
import { GridToolbar } from '@mui/x-data-grid-premium';

/** Internal Components. */
import { customized_style } from '../../theme/Styles';

export default function RefTable(props) {
    /** Get props from Account.js. */
    const { accounts, refRow } = props;
    /** Get props from AccountTable.js. */
    const { selectedId } = props;
    /** Get props from RefDialog.js. */
    const { rowSelectionModel, setRowSelectionModel } = props;

    /** Update the row selection model when the selected ID changes. */
    useEffect(() => {
        const selectedItem = [...accounts]
            .filter((item) => item.id === selectedId)
            .map((item) => {
                return item.filteration.map((obj) => obj.id);
            })
            .flat();
        setRowSelectionModel(selectedItem);
    }, [selectedId]);

    /** Define References Datagrid Fields. */
    const ref_col = [
        { field: 'id', headerName: 'ID', width: 50, align: 'center', headerAlign: 'center' },
        {
            field: 'name',
            headerName: 'Name',
            width: 500,
            align: 'center',
            headerAlign: 'center',
        },
    ];

    return (
        <Box sx={{ height: '400px' }}>
            <DataGridPremium
                rows={refRow}
                columns={ref_col}
                density="compact"
                sx={customized_style.itemDatagrid2}
                onRowSelectionModelChange={(newRowSelectionModel) => {
                    setRowSelectionModel(newRowSelectionModel);
                }}
                rowSelectionModel={rowSelectionModel}
                checkboxSelection
                slots={{ toolbar: GridToolbar }}
                slotProps={{
                    toolbar: {
                        showQuickFilter: true,
                    },
                }}
                initialState={{
                    ...refRow.initialState,
                    columns: {
                        ...refRow.initialState?.columns,
                        columnVisibilityModel: {
                            id: false,
                        },
                    },
                }}
            />
        </Box>
    );
}
